import { useEffect } from "react";
import { NotFoundWrapper } from "./styles/notfound.styled";
import { Link, useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";

const NotFound = () => {
    const navigate=useNavigate();
    useEffect(()=>{
        navigate("/404");
    },[])
    return (
        <NotFoundWrapper>
            <Typography sx={{ fontSize:{xs:28, md:50}}}>Sorry couldn't find the page you are looking for...</Typography>
            {/* <p>Please click <Link to="/">here</Link> to get started.</p> */}
        </NotFoundWrapper>
    )
}
export default NotFound;